import Vue from 'vue'
import VueRouter from 'vue-router'
import Stroe from '../store/index'

import Home from '../views/home/Home.vue'
import Login from '../views/login/login.vue'

import Employee from '../views/Employee/Employee.vue'
import Sporadic from '../views/Sporadic/Sporadic.vue'
import Remittance from '../views/Remittance/Remittance.vue'
import Evection from '../views/Evection/Evection.vue'
import WorkReport from '../views/WorkReport/WorkReport.vue'
import ReportApprove from '../views/ReportApprove/ReportApprove.vue'
import MailRecords from '../views/MailRecords/MailRecords.vue'
import QuotationApply from '../views/QuotationApply/QuotationApply.vue'
import ContractTemplate from '@/views/ContractTemplate/ContractTemplate.vue'
import ContractManagement from '@/views/ContractManagement/ContractManagement.vue'
Vue.use(VueRouter) // 需要与引用VueRouter

// 初始化默认路由
const initMenu = [
  {
    path: '/',
    redirect: '/Login'
  },
  {
    name: 'Login',
    path: '/Login',
    component: Login
  },
  {
    name: 'Home',
    path: '/Home',
    component: Home,
    children: [
      {
        name: 'HomeRedirect',
        path: '/HomeRedirect',
        component: () => import('../views/home/HomeRedirect.vue')
      },
      {
        name: 'Employee',
        path: '/Employee',
        component: Employee
      },
      {
        name: 'Sporadic',
        path: '/Sporadic',
        component: Sporadic
      },
      {
        name: 'Remittance',
        path: '/Remittance',
        component: Remittance
      },
      {
        name: 'Evection',
        path: '/Evection',
        component: Evection
      },
      {
        name: 'WorkReport',
        path: '/WorkReport',
        component: WorkReport
      },
      {
        name: 'ReportApprove',
        path: '/ReportApprove',
        component: ReportApprove
      },
      {
        name: 'MailRecords',
        path: '/MailRecords',
        component: MailRecords
      },
      {
        name: 'QuotationApply',
        path: '/QuotationApply',
        component: QuotationApply
      },
      {
        name: 'ContractTemplate',
        path: '/ContractTemplate',
        component: ContractTemplate
      },
      {
        name: 'ContractManagement',
        path: '/ContractManagement',
        component: ContractManagement
      }
    ]
  },
  {
    name: 'AppSporadic',
    path: '/AppSporadic',
    component: () => import('../views/app/pages/Sporadic/index.vue')
  },
  {
    name: 'AppSporadicDetail',
    path: '/AppSporadicDetail',
    component: () => import('../views/app/pages/Sporadic/detail.vue')
  },
  {
    name: 'AppRemittance',
    path: '/AppRemittance',
    component: () => import('../views/app/pages/Remittance/index.vue')
  },
  {
    name: 'AppRemittanceDetail',
    path: '/AppRemittanceDetail',
    component: () => import('../views/app/pages/Remittance/detail.vue')
  },
  {
    name: 'AppEvection',
    path: '/AppEvection',
    component: () => import('../views/app/pages/Evection/index.vue')
  },
  {
    name: 'AppEvectionDetail',
    path: '/AppEvectionDetail',
    component: () => import('../views/app/pages/Evection/detail.vue')
  },
  {
    name: 'AppWorkReport',
    path: '/AppWorkReport',
    component: () => import('../views/app/pages/WorkReport/index.vue')
  },
  {
    name: 'AppWorkReportDetail',
    path: '/AppWorkReportDetail',
    component: () => import('../views/app/pages/WorkReport/detail.vue')
  },
  {
    name: 'AppReportApprove',
    path: '/AppReportApprove',
    component: () => import('../views/app/pages/ReportApprove/index.vue')
  },
  {
    name: 'AppReportApproveDetail',
    path: '/AppReportApproveDetail',
    component: () => import('../views/app/pages/ReportApprove/detail.vue')
  },
  {
    name: 'AppMailRecords',
    path: '/AppMailRecords',
    component: () => import('../views/app/pages/MailRecords/index.vue')
  },
  {
    name: 'AppMailRecordsDetail',
    path: '/AppMailRecordsDetail',
    component: () => import('../views/app/pages/MailRecords/detail.vue')
  },
  {
    name: 'AppQuotationApply',
    path: '/AppQuotationApply',
    component: () => import('../views/app/pages/QuotationApply/index.vue')
  },
  {
    name: 'AppQuotationApplyDetail',
    path: '/AppQuotationApplyDetail',
    component: () => import('../views/app/pages/QuotationApply/detail.vue')
  }
]

// 初始化 router 实例
const createRouter = () =>
  new VueRouter({
    mode: 'hash',
    routes: initMenu
  })
// 创建路由实例 -- 最终使用的
const router = createRouter()

const routerPush = VueRouter.prototype.push
// // 重定义router.push方法
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}

// 路由访问前
router.beforeEach((to, before, next) => {
  // to 将要访问的路径
  // from 代表从那个路径跳转过来
  // next 是一个函数，表示放行
  // 判断是否到登陆页面
  if (to.path === '/Login') {
    return next()
  }
  // 判断是否存在token
  if (!Stroe.state.accessToken) {
    return next('/Login')
  }
  // 登陆成功进入home
  if (to.path === '/Home') {
    return next('/HomeRedirect')
  }
  next()
})
// router.afterEach(() => {
//   history.pushState(null, null, location.href)
// })

export default router
